import apiHeader from '@/helpers/apiHeader';

const activityTypeService = {
  list(page, params) {
    return apiHeader.get('activity-types?page=' + page, { params }); // Ambil daftar activity types dengan pagination
  },
  get(id) {
    return apiHeader.get('activity-types/' + id); // Ambil detail activity type berdasarkan ID
  },
};

export default activityTypeService;
